module.exports = __webpack_public_path__ + "img/info_gray.032cf42b.svg";